import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageCompliance(){
  var T=React.useContext(ThemeCtx).T;
  var _data=useState([]); var data=_data[0]; var setData=_data[1];
  var _loading=useState(true); var loading=_loading[0]; var setLoading=_loading[1];
  var _sel=useState(null); var sel=_sel[0]; var setSel=_sel[1];
  useEffect(function(){api.get("/compliance").then(function(d){setData(d);setLoading(false);}).catch(function(){setLoading(false);});}, []);
  var statusColor={Compliant:"#22c55e",Partial:"#f97316","Non-Compliant":"#ef4444"};
  var PURPLE="#A100FF";
  if(loading) return React.createElement("div",{style:{color:T.text3,padding:40,textAlign:"center"}},"Loading compliance data...");
  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:14}},
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:10}},
      data.map(function(fw){
        return React.createElement("div",{key:fw.code,onClick:function(){setSel(sel===fw.code?null:fw.code);},
          style:{background:T.card,border:"2px solid "+(sel===fw.code?PURPLE:T.border),padding:"16px",cursor:"pointer"}},
          React.createElement("div",{style:{fontSize:11,fontWeight:700,color:PURPLE,letterSpacing:1,textTransform:"uppercase",marginBottom:4}},fw.code),
          React.createElement("div",{style:{fontSize:12,color:T.text2,marginBottom:12}},fw.name),
          React.createElement("div",{style:{display:"flex",alignItems:"center",gap:12,marginBottom:10}},
            React.createElement("div",{style:{position:"relative",width:56,height:56,flexShrink:0}},
              React.createElement("svg",{width:56,height:56,viewBox:"0 0 56 56"},
                React.createElement("circle",{cx:28,cy:28,r:22,fill:"none",stroke:T.border,strokeWidth:6}),
                React.createElement("circle",{cx:28,cy:28,r:22,fill:"none",stroke:statusColor[fw.status]||PURPLE,strokeWidth:6,strokeDasharray:(fw.score/100)*138.2+" "+138.2,strokeDashoffset:34.5,strokeLinecap:"round"}),
                React.createElement("text",{x:28,y:33,textAnchor:"middle",fontSize:13,fontWeight:700,fill:statusColor[fw.status]||PURPLE},fw.score+"%")
              )
            ),
            React.createElement("div",null,
              React.createElement("div",{style:{fontSize:14,fontWeight:700,color:statusColor[fw.status]||PURPLE}},fw.score+"%"),
              React.createElement("div",{style:{fontSize:11,color:T.text3}},fw.status),
              React.createElement("div",{style:{fontSize:10,color:T.text3,marginTop:2}},fw.controls.filter(function(ctrl){return ctrl.pass;}).length+"/"+fw.controls.length+" controls")
            )
          ),
          React.createElement("div",{style:{height:4,background:T.border,overflow:"hidden"}},
            React.createElement("div",{style:{width:fw.score+"%",height:"100%",background:statusColor[fw.status]||PURPLE}})
          )
        );
      })
    ),
    sel&&React.createElement("div",null,
      data.filter(function(fw){return fw.code===sel;}).map(function(fw){
        return React.createElement("div",{key:fw.code,style:{background:T.card,border:"1px solid "+T.border,padding:"16px"}},
          React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}},
            React.createElement("div",null,
              React.createElement("div",{style:{fontSize:15,fontWeight:700,color:T.text}},fw.name),
              React.createElement("div",{style:{fontSize:12,color:T.text3}},fw.description)
            ),
            React.createElement("div",{style:{display:"flex",gap:8,fontSize:12}},
              React.createElement("span",{style:{color:T.text3}},fw.stats.total+" total"),
              React.createElement("span",{style:{color:"#ef4444"}},fw.stats.criticalOpen+" critical"),
              React.createElement("span",{style:{color:"#22c55e"}},fw.stats.remediated+" remediated"),
              fw.stats.overdue>0&&React.createElement("span",{style:{color:"#f97316"}},fw.stats.overdue+" overdue")
            )
          ),
          React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
            React.createElement("thead",null,React.createElement("tr",{style:{background:T.inset}},
              ["Control ID","Title","Status","Detail"].map(function(h){return React.createElement("th",{key:h,style:{padding:"8px 12px",textAlign:"left",fontSize:10,fontWeight:700,color:T.text3,textTransform:"uppercase",letterSpacing:.8}},h);})
            )),
            React.createElement("tbody",null,
              fw.controls.map(function(ctrl,i){
                return React.createElement("tr",{key:ctrl.id,style:{borderTop:"1px solid "+T.border,background:i%2===0?"transparent":T.inset+"44"}},
                  React.createElement("td",{style:{padding:"8px 12px",fontSize:11,fontWeight:700,color:PURPLE}},ctrl.id),
                  React.createElement("td",{style:{padding:"8px 12px",fontSize:12,color:T.text}},ctrl.title),
                  React.createElement("td",{style:{padding:"8px 12px"}},React.createElement("span",{style:{background:(ctrl.pass?"#22c55e":"#ef4444")+"22",color:ctrl.pass?"#22c55e":"#ef4444",border:"1px solid "+(ctrl.pass?"#22c55e":"#ef4444")+"44",padding:"2px 8px",fontSize:10,fontWeight:700}},ctrl.pass?"PASS":"FAIL")),
                  React.createElement("td",{style:{padding:"8px 12px",fontSize:11,color:T.text3}},ctrl.detail)
                );
              })
            )
          )
        );
      })
    )
  );
}

